<template>
    <router-view></router-view>
</template>

<script>
export default {
  name: "Base"
}
</script>

<style scoped>

</style>